import {
  productTaxonomyDisplayOptions,
  productTaxonomyTypeOptions,
} from '@/configuration/pages/ConfigurationPage/ExtrasConfiguration/TryOnWidgetConfigurationPage/constants'

export const productTaxonomyIdsLabels = {
  [productTaxonomyTypeOptions.category]: {
    [productTaxonomyDisplayOptions.included]: 'Categorías de producto seleccionadas',
    [productTaxonomyDisplayOptions.excluded]: 'Categorías de producto excluidas',
  },
  [productTaxonomyTypeOptions.collection]: {
    [productTaxonomyDisplayOptions.included]: 'Colecciones seleccionadas',
    [productTaxonomyDisplayOptions.excluded]: 'Colecciones excluidas',
  },
  [productTaxonomyTypeOptions.tag]: {
    [productTaxonomyDisplayOptions.included]: 'Etiquetas de producto',
    [productTaxonomyDisplayOptions.excluded]: 'Tags excluidos',
  },
}
